import {
  BeneficiaryComputedInsightWidgetDTO,
  BeneficiaryCreateInsightWidgetDTO,
  BeneficiaryFiltersDTO,
  BeneficiaryInsightDimensionsDTO,
  BeneficiaryInsightDisplayType,
  BeneficiaryInsightMetricsDTO,
  BeneficiaryInsightWidgetDTO,
} from '../dtos/beneficiary'
import { RequestPayload, ResponseData } from '../dtos/generic'
import { defineRoute } from './new-helpers'

export const BeneficiariesInsightWidgetsRoutes = {
  createOne: defineRoute<
    'POST',
    ResponseData<BeneficiaryInsightWidgetDTO>,
    RequestPayload<BeneficiaryCreateInsightWidgetDTO>
  >({
    path: `/organizations/:organizationId/beneficiaries/insight-widgets`,
  }),
  patchOne: defineRoute<
    'PATCH',
    ResponseData<BeneficiaryInsightWidgetDTO>,
    RequestPayload<
      Partial<{
        title: string
        type: BeneficiaryInsightDisplayType
        description: string
        width: number
        height: number
        metrics: BeneficiaryInsightMetricsDTO
        dimensions: BeneficiaryInsightDimensionsDTO
        filters: BeneficiaryFiltersDTO
        position: number
      }>
    >
  >({
    path: `/organizations/:organizationId/beneficiaries/insight-widgets/:widgetId`,
  }),
  getAll: defineRoute<'GET', ResponseData<BeneficiaryInsightWidgetDTO[]>>({
    path: `/organizations/:organizationId/beneficiaries/insight-widgets`,
  }),
  getAllComputed: defineRoute<'GET', ResponseData<BeneficiaryComputedInsightWidgetDTO[]>>({
    path: `/organizations/:organizationId/beneficiaries/all-insight-widgets`,
  }),
  getOne: defineRoute<'GET', ResponseData<BeneficiaryInsightWidgetDTO>>({
    path: `/organizations/:organizationId/beneficiaries/insight-widgets/:widgetId`,
  }),
  getComputed: defineRoute<'GET', ResponseData<BeneficiaryComputedInsightWidgetDTO>>({
    path: `/organizations/:organizationId/beneficiaries/insight-widgets/computed/:widgetId`,
  }),
  toggleDisplayInDashboard: defineRoute<'PATCH', ResponseData<boolean>>({
    path: `/organizations/:organizationId/beneficiaries/insight-widgets/:widgetId/toggle-display-in-dashboard`,
  }),
  deleteOne: defineRoute<'DELETE', ResponseData<void>>({
    path: `/organizations/:organizationId/beneficiaries/insight-widgets/:widgetId`,
  }),
}
